import { useCallback, useEffect, useState } from 'react';

const localMidnightV97 = () => {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
};

export default function useTodayV97() {
  const [today, setToday] = useState(localMidnightV97);
  const refreshToday = useCallback(() => setToday(localMidnightV97()), []);

  useEffect(() => {
    let timer;
    const refresh = () => {
      refreshToday();
      clearTimeout(timer);
      const now = new Date();
      // Calendar midnights are not always 24 hours apart (DST).
      const next = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate() + 1
      );
      timer = setTimeout(refresh, Math.max(1, next.getTime() - now.getTime()));
    };
    const onVisibility = () => {
      if (document.visibilityState === 'visible') refresh();
    };
    refresh();
    window.addEventListener('focus', refresh);
    window.addEventListener('pageshow', refresh);
    document.addEventListener('visibilitychange', onVisibility);
    return () => {
      clearTimeout(timer);
      window.removeEventListener('focus', refresh);
      window.removeEventListener('pageshow', refresh);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, [refreshToday, today]);

  return [today, refreshToday];
}
